/**
 * Generato automaticamente.
 * framework-cfg-procedimenti
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { TipoSezioneDocumentoDto } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Dettaglio tipo sezione documento
 * @summary Dettaglio tipo sezione documento
 */
export const getTipoSezioneDocumentoId = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<TipoSezioneDocumentoDto>(
    {
      url: `/framework-cfg-procedimenti/tipo-sezione-documento/${id}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetTipoSezioneDocumentoIdQueryKey = (id: string) =>
  [`/framework-cfg-procedimenti/tipo-sezione-documento/${id}`] as const;

export const getGetTipoSezioneDocumentoIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipoSezioneDocumentoId>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipoSezioneDocumentoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getTipoSezioneDocumentoId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTipoSezioneDocumentoIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipoSezioneDocumentoId>>
  > = ({ signal }) => getTipoSezioneDocumentoId(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetTipoSezioneDocumentoIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipoSezioneDocumentoId>>
>;
export type GetTipoSezioneDocumentoIdQueryError = ErrorType<unknown>;

/**
 * @summary Dettaglio tipo sezione documento
 */
export const useGetTipoSezioneDocumentoId = <
  TData = Awaited<ReturnType<typeof getTipoSezioneDocumentoId>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipoSezioneDocumentoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipoSezioneDocumentoIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
